<template>
	<v-navigation-drawer
			ref="sideNav"
			v-model="isOpen"
			v-click-outside="() => clickOutsideOptions"
			aria-label="Main Navigation"
			class="white"
			:expand-on-hover="sideNavState.hover"
			fixed
			:mini-variant="sideNavState.hover"
			:permanent="sideNavState.permanent"
			tag="nav"
			:temporary="sideNavState.temporary"
	>
		<!-- Side Header -->
		<v-toolbar
				class="d-flex justify-space-between position-fixed w-100 z-3"
				flat
		>
			<!-- Logo -->
			<div class="ms-n1 side-nav-logo"></div>
			<!-- END Logo -->
			<v-spacer v-if="$vuetify.breakpoint.name === 'xs'"></v-spacer>
			<!-- Closer - Hide for now while some styles are sorted -->
			<v-btn
					v-if="$vuetify.breakpoint.name === 'xs' && 2 === 1"
					class="me-n1"
					dark
					icon
					style="width: 38px"
					@click="closeSideNav"
			>
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<!-- END Closer -->
		</v-toolbar>
		<!-- END Side Header -->

		<!-- Side Navigation -->
		<v-list v-if="menuHeaders.length > 0" class="mt-16" expand>
			<template v-for="(menuHeader, idx) in menuHeaders">
				<div :key="`nav-section-${getTitle(menuHeader[0])}-${idx}`">
					<div v-if="menuHeader.length === 1">
						<!-- TODO: Not sure what this item is ??? -->
						<template v-if="getLink(menuHeader[0])[0] === '#'">
							<v-list-item :href="`${partner.id}/${getLink(menuHeader[0])}`">
								<v-list-item-icon>
									<v-icon>{{ menuHeader[0].class }}</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ getTitle(menuHeader[0]) }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</template>

						<!-- Text level entry -->
						<template v-else-if="menuHeader[0].text">
							<v-list-item dense>
								<v-list-item-icon>
									<v-icon
											v-if="menuHeader[0].class"
											:class="{
												'success--text': isComplete(menuHeader[0]) === 1,
												'info--text': isComplete(menuHeader[0]) === 0
											}"
									>
										{{ menuHeader[0].class }}
									</v-icon>
								</v-list-item-icon>
								<v-list-item-content
										class="text-caption"
										:class="{
											'font-weight-medium': isComplete(menuHeader[0]) === 0
										}"
								>
									{{ getText(menuHeader[0]) }}
									<!-- right icon was here -->
								</v-list-item-content>
							</v-list-item>
						</template>

						<!-- Modal level entry -->
						<template v-else-if="menuHeader[0].name === 'modal'">
							<v-list-item
									id="myCustomTrigger"
									v-ripple="{ class: 'side-nav-ripple' }"
									dense
									style="cursor: pointer;"
							>
								<v-list-item-icon>
									<v-icon v-if="menuHeader[0].class">
										{{ menuHeader[0].class }}
									</v-icon>
									<i
											v-if="3 === 2"
											:class="[
                      'd-flex align-center justify-center nav-main-link-icon',
                      menuHeader[0].class
                    ]"
									></i>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ getTitle(menuHeader[0]) }}
									</v-list-item-title>
									<!-- right icon was here -->
								</v-list-item-content>
							</v-list-item>
						</template>

						<!-- Single level entry -->
						<template v-else-if="getLink(menuHeader[0])">
							<v-list-item
									v-ripple="{ class: 'side-nav-ripple' }"
									:class="[
                  checkRoute(getLink(menuHeader[0]))
											? 'v-list-item--active--force'
											: ''
									]"
									dense
									:href="getLink(menuHeader[0])"
									:target="menuHeader[0].target ? menuHeader[0].target : ''"
							>
								<v-list-item-icon>
									<v-icon v-if="menuHeader[0].class">
										{{ menuHeader[0].class }}
									</v-icon>
									<i
											v-if="3 === 2"
											:class="[
												'd-flex align-center justify-center nav-main-link-icon',
												menuHeader[0].class
											]"
									></i>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ getTitle(menuHeader[0]) }}
									</v-list-item-title>
									<!-- right icon was here -->
								</v-list-item-content>
							</v-list-item>
						</template>

						<!-- This is a section heading -->
						<template v-else>
							<v-list-item class="section-heading grey--text mb-0 mt-4" dense>
								<v-list-item-icon>
									<v-icon :color="menuHeader[0].class">mdi-rhombus-medium</v-icon>
								</v-list-item-icon>
								<v-list-item-content style="flex: initial">
									<v-list-item-title
											:class="[
                      'font-weight-bold',
                      'text-caption',
                      'text--grey',
                      'text--lighten-3',
                      'text-uppercase'
                    ]"
									>
										{{ getTitle(menuHeader[0]) }}
									</v-list-item-title>
								</v-list-item-content>
								<v-divider class="flex-grow-1 ms-2 my-0"></v-divider>
							</v-list-item>

							<!-- Modal level entry -->
							<template v-if="menuHeader[0].name === 'modal'">
								<v-list-item
										id="myCustomTrigger"
										v-ripple="{ class: 'side-nav-ripple' }"
										dense
										style="cursor: pointer;"
								>
									<v-list-item-icon>
										<v-icon v-if="menuHeader[0].class">
											{{ menuHeader[0].class }}
										</v-icon>
										<i
												v-if="3 === 2"
												:class="[
                      'd-flex align-center justify-center nav-main-link-icon',
                      menuHeader[0].class
                    ]"
										></i>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											{{ getTitle(menuHeader[0]) }}
										</v-list-item-title>
										<!-- right icon was here -->
									</v-list-item-content>
								</v-list-item>
							</template>
						</template>

					</div>

					<!-- Multi-level entry -->
					<div v-else>
						<v-list-group :value="checkSubRoute(menuHeader)">
							<!-- Opener for sub menus -->
							<template v-slot:activator>
								<v-list-item-icon>
									<v-icon>{{ menuHeader[0].class }}</v-icon>
									<i
											v-if="3 === 2"
											:class="[
												'd-flex align-center justify-center nav-main-link-icon',
												menuHeader[0].class
											]"
									></i>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title>
										{{ getTitle(menuHeader[0]) }}
									</v-list-item-title>
								</v-list-item-content>
							</template>

							<!-- Sub menu items -->
							<template v-for="(menuItem, idx) in menuHeader">
								<v-list-item
										v-if="idx > 0"
										:key="`nav-sub-item-${getTitle(menuItem)}-${idx}`"
										:class="[
                    'sub-item',
                    checkRoute(getLink(menuItem))
											? 'v-list-item--active--force'
											: ''
										]"
										dense
										:href="
                    getAdminLink(
                      menuItem,
                      menuHeader[0] &&
                        getLink(menuHeader[0]) &&
                        getLink(menuHeader[0]).includes('/superAdmin')
                    )
                  "
								>
									<v-list-item-icon>
										<v-icon small>{{ menuItem.class }}</v-icon>
										<i
												v-if="3 === 2"
												:class="[
													'd-flex align-center nav-main-link-icon',
													menuItem.class
												]"
										></i>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>
											{{ getTitle(menuItem) }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-divider
										v-if="idx === menuHeader.length - 1"
										:key="`nav-sub-item-divider-${getTitle(menuItem)}-${idx}`"
										class="mt-0 mx-4"
								/>
							</template>

						</v-list-group>
					</div>
				</div>
			</template>
		</v-list>
		<!-- END Side Navigation -->
	</v-navigation-drawer>
	<!-- END Sidebar -->
</template>

<script>

export default {
	name: 'SideNav',
	props: {
		appUrl: {
			type: String,
			default: ''
		},
		fullUrl: {
			type: String,
			default: ''
		},
		menuHeaders: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object,
			default: () => ({ id: 0, name: 'Bandwango (Super Admin)' })
		},
		venue: {
			type: Object,
			default: () => ({})
		},
		venuePendingActions: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			hasSecondaryMenu: false,
			isOpen: false,
			includedClickElements: null
		};
	},
	computed: {
		breakpoint() {
			return this.$vuetify.breakpoint.name;
		},
		clickOutsideOptions() {
			const appBarNavIconEl = document.querySelector('.v-app-bar__nav-icon');
			if(appBarNavIconEl) {
				return {
					handler: this.closeSideNav,
					include: [appBarNavIconEl]
				};
			}
			return {};
		},
		sideNavState() {
			return {
				hover:
						this.$vuetify.breakpoint.smOnly ||
						this.$vuetify.breakpoint.mdOnly ||
						(!this.$vuetify.breakpoint.xs && this.hasSecondaryMenu),
				temporary: this.$vuetify.breakpoint.xs,
				permanent: this.$vuetify.breakpoint.smAndUp
			};
		}
	},
	methods: {
		checkRoute(routeName) {
			// don't highlight Dashboard every time
			if(
					routeName === `/admin/${this.partner.id}` &&
					this.fullUrl !== `${this.appUrl}/admin/${this.partner.id}`
			) {
				// console.log('case: 1');
				return false;
			}

			// don't highlight Dashboard every time
			if(
					routeName === '/superAdmin' &&
					this.fullUrl !== `${this.appUrl}/superAdmin`
			) {
				// console.log('case: 2');
				return false;
			}

			return `${this.fullUrl}/`.search(routeName) > -1;
		},
		checkSubRoute(menuHeader) {
			if(Array.isArray(menuHeader))
				return menuHeader.some(item => this.checkRoute(item.link));

			return false;
		},
		closeSideNav() {
			this.isOpen = false;
			document.body.classList.remove('side-nav--open');
		},
		getAdminLink(menuItem, isSuperAdmin = false) {
			return menuItem.link.search(/superAdmin/i) > -1 || isSuperAdmin
					? `/superAdmin${menuItem.link}`
					: `/admin/${this.partner.id}${menuItem.link}`;
		},
		getLink(item) {
			return item?.link || '';
		},
		getText(item) {
			return item?.text || '';
		},
		getTitle(item) {
			return item?.title || '';
		},
		isComplete(item) {
			return item?.complete;
		},
		onClassChange(classAttrValue) {
			const classList = classAttrValue.split(' ');
			this.hasSecondaryMenu = classList.includes('has-secondary-nav');
			this.isOpen = classList.includes('side-nav--open');
		},
	},
	beforeCreate() {
		document.body.classList.add(`breakpoint-${this.$vuetify.breakpoint.name}`);
	},
	mounted() {

		this.observer = new MutationObserver(mutations => {
			mutations.forEach(m => {
				const newValue = m.target.getAttribute(m.attributeName);
				this.$nextTick(() => {
					this.onClassChange(newValue, m.oldValue);
				});
			});
		});

		this.observer.observe(document.body, {
			attributes: true,
			attributeOldValue: true,
			attributeFilter: ['class']
		});
	},
	beforeDestroy() {
		this.observer.disconnect();
	},
	watch: {
		breakpoint: {
			handler(newValue, oldValue) {
				document.body.classList.remove(`breakpoint-${oldValue}`);
				document.body.classList.add(`breakpoint-${newValue}`);

				if(newValue === 'xs') {
					this.$nextTick(() => {
						document.body.classList.remove('side-nav--open');
					});
				}
			}
		},
		isOpen: {
			handler(newValue) {
				if(!newValue) document.body.classList.remove('side-nav--open');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
#side-nav {
	transition: width 300ms ease-in-out;
}
</style>

<style lang="scss" scoped>
.v-list {
	background: none !important;
}

.v-list-item:not(.v-list-group__header) {
	&.v-list-item--active--force {
		& .v-icon,
		& .v-list-item__content {
			color: var(--v-primary-darken2);
		}

		&:not(:hover):not(:focus) {
			& .v-icon,
			& .v-list-item__content {
				color: var(--v-primary-base);
			}

			&:before {
				background: var(--v-primary-base);
				opacity: 0.05 !important;
			}
		}

		&:before {
			background: var(--v-primary-base);
			opacity: 0.12 !important;
		}
	}
}

::v-deep .v-list-item {
	border-radius: 0.25rem;
	min-height: 40px !important;
	margin: 0.125rem 0.75rem;
	padding: 0 1rem;

	&--active:not(:hover):not(:focus):before {
		opacity: 0.05 !important;
	}

	&::before {
		border-radius: 0.25rem;
	}
}

.v-list-item .v-list-item__title {
	font-size: 0.8125rem;
}

.v-list-item .v-list-item__content,
.v-list-item__content {
	padding: 8px 0;
}

.v-list-item__icon {
	margin: 8px 0;
}

::v-deep .v-list-group__items .v-list-item {
	margin-left: 3.25rem;
	overflow: visible;
	padding: 0 16px;
}

.v-list-item__icon .v-icon {
	opacity: 0.5;
}

.v-list > div:last-child .v-list-group--active .v-list-group__items hr {
	display: none !important;
}

::v-deep .v-list-group__items .v-list-item__icon::before {
	position: absolute;
	content: '';
	height: 1rem;
	width: 0.5rem;
	border-bottom-left-radius: 6px;
	border-left: dotted 1px #ccc;
	border-bottom: dotted 1px #ccc;
	left: -12px;
	top: 4px;
	opacity: 0;
	transition: opacity 300ms ease-in-out;
}

@for $i from 1 to 12 {
	::v-deep .v-list-group__items {
		& .v-list-item:nth-child(#{$i}) {
			& .v-list-item__icon::before {
				top: #{(($i - 1) * -42) + 4}px;
				height: #{(($i - 1) * 2.6275) + 1}rem;
			}
		}
	}
}

::v-deep .v-list-group__items .v-list-item:hover .v-list-item__icon::before {
	opacity: 1;
}

.v-navigation-drawer--mini-variant {
	& .v-list ::v-deep .v-list-group--active {
		& .v-list-group__items {
			height: 100%;
			opacity: 1;
			transition: opacity 300ms ease-in-out, height 300ms ease-in-out;
		}
	}

	& .v-list:not(:hover) ::v-deep .v-list-group--active {
		& .v-list-group__items {
			height: 0;
			opacity: 0;
		}
	}
}

.v-navigation-drawer ::v-deep .v-list-item {
	transition: padding 300ms ease-in-out;
}

.v-navigation-drawer--mini-variant:not(:hover) ::v-deep .v-list-item {
	padding: 0 0.25rem;
}

#side-nav {
	width: 256px !important;
	z-index: 6;
}

#side-nav.v-navigation-drawer--mini-variant {
	width: 56px !important;
}

.v-navigation-drawer ::v-deep .v-list-item--active {
	border: solid 0 transparent;
}

.v-navigation-drawer.v-navigation-drawer--mini-variant {
	&:not(.v-navigation-drawer--is-mouseover) {
		& ::v-deep .v-list-item--active {
			border: solid 1px var(--v-primary-lighten2);
			min-height: 38px !important;

			&::before {
				opacity: 0.1 !important;
			}
		}
	}
}

.v-list-group .v-list-group__header .v-list-item__title {
	font-weight: 500;
}

::v-deep .v-list-group__items .v-list-item--active--force {
}

.side-nav-logo {
	height: 60px;
	background-image: url('/images/logo_bw_white.svg');
	background-position: right center;
	background-size: cover;
	transition: width 300ms ease-in-out;
}

body.breakpoint-sm .side-nav-logo,
body.breakpoint-md .side-nav-logo,
body.breakpoint-lg .v-navigation-drawer--mini-variant .side-nav-logo,
body.breakpoint-xl .v-navigation-drawer--mini-variant .side-nav-logo {
	width: 37px;
}

body.breakpoint-xs .side-nav-logo,
body.breakpoint-lg .side-nav-logo,
body.breakpoint-xl .side-nav-logo,
body.breakpoint-sm .v-navigation-drawer--is-mouseover .side-nav-logo,
body.breakpoint-md .v-navigation-drawer--is-mouseover .side-nav-logo {
	width: 144px;
}

.v-navigation-drawer--mini-variant .v-list-group__items {
	display: none;
}

body.breakpoint-xs .v-navigation-drawer header .v-toolbar__content {
	width: 100%;
}

#side-nav .v-navigation-drawer__content {
	-ms-overflow-style: none; /* for Internet Explorer, Edge */
	scrollbar-width: none; /* for Firefox */
	overflow-y: scroll;
}

#side-nav .v-navigation-drawer__content::-webkit-scrollbar {
	display: none; /* for Chrome, Safari, and Opera */
}

.v-navigation-drawer__content > header {
	background-color: #222 !important;
}
</style>